import FileCopyIcon from "@mui/icons-material/FileCopy";
import { Button, Collapse, Typography, Box, IconButton, Checkbox } from "@mui/material";
import { makeStyles } from '@mui/styles';
import { GridColDef, GridRowModel, DataGrid, GridPagination } from '@mui/x-data-grid';
import useActionItems from "../../hooks/useActionItems";
import { useMemo } from "react";
import LaunchIcon from "@mui/icons-material/Launch"
import { useManageModal } from "ui";
import usePersonAuthStore from "../../../store/personAuthStore"
import { useTourContext } from "../../../../context/TourContext";
import { format } from "date-fns";
const useStyles = makeStyles({
    root: {
        '& .MuiDataGrid-autoHeight': {
            minHeight: "212px"
        },
        '& .results-grid': {
            backgroundColor: "#F03F3F",
        },
        '& .results-grid--Severe': {
            backgroundColor: "#FEE2E2",
        },
        '& .MuiDataGrid-columnsContainer': {
            backgroundColor: "#8E1C3B",
            color: "#fff"
        },
        "& .MuiDataGrid-root": {
            background: "#fff",
            border: "none",
            boxShadow: "rgb(0 0 0 / 20%) 0px 2px 4px -1px, rgb(0 0 0 / 14%) 0px 4px 5px 0px, rgb(0 0 0 / 12%) 0px 1px 10px 0px"
        },
        "& .MuiDataGrid-columnSeparator": {
            display: "none"
        },
        "& .MuiDataGrid-sortIcon": {
            color: "#fff"
        },
        "& .MuiDataGrid-menuIconButton": {
            color: "#fff"
        },
        "& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus": {
            outline: "none",
        },
        "& .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-columnHeader:focus":
        {
            outline: "none",
        },
    },
});
const DEFAULT_PAGE_SIZE = 100;

export interface RiskWarningGridProps {
    onClickResults: (value: any) => void,
}


function SampleRiskWarningGrid({ ...props }) {
    const firstSignIn = usePersonAuthStore(state => state.firstSignIn)
    const classes = useStyles();
    const { openModal, closeModal } = useManageModal();
    const { actionItems } = useActionItems();
    const { tutorialSection } = useTourContext()
    const RISK_WARNING_COLUMNS: GridColDef[] = [{
        field: 'createdAt',
        headerName: "Date of Session",
        headerAlign: "center",
        flex: 1,
        minWidth: 0,
        renderHeader: () => (
            <div style={{ whiteSpace: "break-spaces", textAlign: "center", fontWeight: 500, lineHeight: 1, justifyContent: "center", width: "100%" }}>Date of Session</div>
        ),
        sortable: false,
        align: "center",
        disableColumnMenu: true,
        // renderCell: ({ value }) => {
        //     return value ?
        //         <div style={{ textAlign: "center" }}> <Typography  >{value.toString()}</Typography></div> : '--'
        // }
    },
    {
        field: 'name', headerName: "Name",
        flex: 4, minWidth: 0,
        sortable: false,
        disableColumnMenu: true,
    },
    {
        field: 'reason', headerName: "Reason",
        flex: 1, minWidth: 0,
        sortable: false,
        disableColumnMenu: true,
    },
    {
        field: "summary",
        headerName: "View Summary",
        sortable: false,
        flex: 1, minWidth: 0,
        align: "center",
        disableColumnMenu: true,
        headerAlign: "center",
        renderHeader: () => (
            <div style={{ whiteSpace: "break-spaces", fontWeight: 500, lineHeight: 1, textAlign: "center", width: "100%" }}>View Summary</div>
        ),
        renderCell: (params) => {

            return <IconButton disabled><FileCopyIcon /></IconButton>;
        }
    },]


    const columns: GridColDef[] = useMemo(() => {
        const cols = [...RISK_WARNING_COLUMNS]
        cols.unshift(
            {
                field: "customCheckbox", headerName: "Mark as Read",
                flex: .5,
                renderHeader: () => (
                    <div style={{ whiteSpace: "break-spaces", fontWeight: 500, lineHeight: 1, textAlign: "center", width: "100%" }}>Mark as Read</div>
                ),
                renderCell: () => (
                    <Box>
                        <Checkbox disabled /></Box>)
            }
        )
        return cols
    }, [])
    const sampleRows: GridRowModel[] = [
        { id: "1", sessionId: "a", studentId: "s1", name: "Sample Urgent Student", createdAt: format(new Date(), "MM/dd/yyyy"), reason: "Urgent", urgency: true },
        { id: "2", sessionId: "b", studentId: "s2", name: "Sample Student", createdAt: format(new Date(), "MM/dd/yyyy"), reason: "Unread", urgency: false }
    ]






    return (
        <Collapse unmountOnExit={false} in={(tutorialSection == "actionsNeeded" && actionItems.length == 0) || firstSignIn} timeout={250} collapsedSize={0} orientation="vertical">
            <Box component="div" sx={{ width: "100%" }} className={classes.root} {...props}>
                <DataGrid
                    autoHeight
                    sx={{
                        ".MuiDataGrid-columnHeader": { backgroundColor: "#8E1C3B", color: "White", },
                        ".MuiDataGrid-columnHeaders": { borderTopLeftRadius: "0px", borderTopRightRadius: "0px" },
                        ".MuiDataGrid-columnSeparator": { display: "none" },
                        ".MuiDataGrid-filler": { display: "none !important" },
                        '& .MuiDataGrid-scrollbarFiller': {
                            display: "none !important",
                        },

                        backgroundColor: "White",
                        width: "100%"
                    }}
                    rows={sampleRows}
                    loading={false}
                    columns={columns}
                    slots={{
                        toolbar: () => (<ActionsNeededToolbar
                            title={`Sample Actions Needed`}
                        />),
                        footer: () => (
                            <ActionsNeededFooter
                            />
                        )
                    }}
                    showToolbar
                    initialState={{
                        pagination: {
                            paginationModel: { pageSize: 6 }
                        }
                    }}
                    pageSizeOptions={[6]}
                />
            </Box>
        </Collapse>
    );
}
type ActionsNeededProps = {
    title: string,
    // onClick: () => {}
}
const ActionsNeededToolbar = ({ title }: ActionsNeededProps) => {
    return (
        <Box component="div"
            sx={{
                padding: "8px 16px", bgcolor: "#8E1C3B", color: "#fff", display: "flex", alignItems: "center", justifyContent: "space-between"
            }}>
            <Typography variant="h4" sx={{ textAlign: "left" }}>
                {title}
            </Typography>
            <Button data-tour="unread-triage"
                disabled
                sx={{ color: "white!important", maxWidth: "225px" }}
                startIcon={<LaunchIcon />}>Get Triage Report of Unread Sessions</Button>
        </Box>
    )
}

const ActionsNeededFooter = () => {
    return (
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Box component="div" sx={{ padding: "2px 16px", display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                <Button disabled >Cancel</Button>
                <Button
                    disableElevation
                    disabled
                    variant="contained"
                // size="large"
                // sx={{
                //     fontSize: ".875rem",
                //     height: "fit-content",
                //     color: "black",
                //     marginLeft: ".5rem",
                //     borderRadius: "4px",
                //     backgroundColor: "rgb(131,164,123)",
                //     fontWeight: "bold",
                //     padding: ".5rem",
                //     "&:hover": { backgroundColor: "rgb(86,117,79)" }
                // }}
                >Save</Button>
            </Box>
            <GridPagination />
        </Box>
    )
}
export default SampleRiskWarningGrid
